Ext.define('SA.view.color.RgbTab', {
    alias: 'widget.rgb-tab',
    extend: 'SA.view.SimpleContainer',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-rgb-tab-primary-container',

            items: [
                {
                    xtype: 'color-window-slider',
                    component: 'r',
                    fieldLabel: 'Red',
                    itemId: 'fieldR'
                }, {
                    xtype: 'color-window-slider',
                    component: 'g',
                    fieldLabel: 'Green',
                    itemId: 'fieldG'
                }, {
                    xtype: 'color-window-slider',
                    component: 'b',
                    fieldLabel: 'Blue',
                    itemId: 'fieldB'
                }, {
                    xtype: 'simple-container',
                    cls: 'sa-rgb-tab-hex-row',

                    items: [
                        {
                            xtype: 'hex-field',

                            listeners: {
                                'select:color': function(view, color) {
                                    view.up('[window]').setColor(color);
                                }
                            }
                        }, {
                            xtype: 'component',
                            cls: 'sa-rgb-tab-hex-row-spacer'
                        }, {
                            xtype: 'simple-container',

                            items: [
                                {
                                    swatchType: 'new',
                                    xtype: 'color-swatch'
                                }, {
                                    swatchType: 'old',
                                    xtype: 'color-swatch',

                                    listeners: {
                                        click(view) {
                                            view.up('[window]').setColor(view.getColor());
                                        }
                                    }
                                }
                            ]
                        }, {
                            xtype: 'sa-button',
                            height: 30,
                            margin: '0 0 0 10',
                            text: 'Use New',
                            width: 82,

                            handler() {
                                this.up('[window]').useColor();
                            }
                        }
                    ]
                }
            ]
        }, {
            xtype: 'component',
            cls: 'sa-color-window-separator'
        }, {
            xtype: 'recent-row',
            margin: '0 0 10',

            listeners: {
                'select:recentColor': function(color) {
                    this.up('[window]').setColor(color);
                }
            }
        }
    ],

    initEvents() {
        var win = this.up('[window]');

        this.callParent();

        this.query('color-window-slider').forEach(slider => {
            slider.on('change:color', onSliderColorChange);
        });

        function onSliderColorChange(field, color) {
            win.setColor(color);
        }
    }
});